'use client'

import React, { ComponentType } from 'react'
import { Game } from 'types'
import { gamePath, gamePresstextPath } from 'shared/urlHelpers'
import Link from '../router/Link'
import { usePathname } from 'next/navigation'

interface TickerNavProps {
  game: Game
  hasTickarooTicker: boolean
  hasEvents: boolean
  hasPresstext: boolean
}

interface TickerNavEntryProps {
  name: string
  href: string
  type?: 'official' | 'normal'
  openInNewWindow?: boolean
  className?: string
}

const lineupId = '#aufstellung'

function TickerNavEntry({
  name,
  href,
  type = 'normal',
  openInNewWindow = false,
  className
}: TickerNavEntryProps) {
  const pathname = usePathname()

  let active: boolean = false
  if (pathname) {
    active =
      pathname === href ||
      pathname + lineupId === href ||
      pathname === href + lineupId ||
      pathname?.endsWith(name.toLowerCase())
  }

  return (
    <span
      className={`ticker-nav-item btn btn-short
          ${type === 'normal' ? 'btn-gray' : 'btn-gray'}
          ${active ? 'btn-blue' : ''}
          ${className}
        `}
    >
      <Link href={href} openInNewWindow={openInNewWindow}>
        {name}
      </Link>
    </span>
  )
}

// FIXME : check if this still does what it should, so few edge cases, not sure...

export const TickerNav: ComponentType<TickerNavProps> = ({
  game,
  hasEvents,
  hasTickarooTicker,
  hasPresstext
}) => {
  return (
    <div className="container-px-0 ticker-nav">
      <div className="flex justify-between xl:flex-nowrap flex-wrap">
        <div className="ticker-nav flex md:flex-1 flex-col md:flex-row md:items-center pr-3 mb-2 md:mb-0 md:space-x-4 space-y-1 md:space-y-0">
          {(!hasTickarooTicker || hasEvents) && (
            <>
              <TickerNavEntry
                name="offizieller Ticker"
                type="official"
                href={gamePath(game)}
              />
              <TickerNavEntry
                name="Aufstellung/Info"
                type="official"
                href={gamePath(game) + lineupId}
              />
            </>
          )}
          {hasPresstext && (
            <TickerNavEntry
              name="Spielbericht"
              href={gamePresstextPath(game)}
            />
          )}
          {hasTickarooTicker && hasEvents && (
            <TickerNavEntry
              name="handball.net-Ticker"
              href={gamePath(game) + '?preferLiveticker=true'}
            />
          )}
          {game.customUrl && (
            <TickerNavEntry
              name={game.customUrlLabel ?? 'Info'}
              href={game.customUrl}
              openInNewWindow
            />
          )}
        </div>
      </div>
    </div>
  )
}
